export default "/site/aidive/js/react/dist/images/olympiacos-hero.a67a7648.jpg";